// extracted by mini-css-extract-plugin
module.exports = {"navInContainer":"logInNav_navInContainer__FU2Qx"};